import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagEs = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M0 0h512v512H0z", fill: "#c60b1e" }),
    React.createElement("path", { d: "M0 128h512v256H0z", fill: "#ffc400" })), '0 0 512 512', 'FlagEs');
//# sourceMappingURL=FlagEs.js.map